/**
 * CritiqueIcon - Icon representing critique/feedback functionality
 * Line-based speech bubble with text lines icon
 */

import type { IconProps } from './IconTypes';

export function CritiqueIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Critique',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Speech bubble */}
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      {/* Pencil/edit mark */}
      <path d="M9 8h6" />
      <path d="M9 12h4" />
    </svg>
  );
}
